import React, { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Box, IconButton, TableFooter, TablePagination, TableContainer } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { getRequest, convertToINR, getHumanReadableDate } from "../../globalhelper/helper";
import { CSVLink } from "react-csv";
function TablePaginationActions(props) {
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    onPageChange
  } = props;
  const [previousCount, setPreviousCount] = useState(count);
  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return <Box sx={{
    flexShrink: 0,
    ml: 2.5
  }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>;
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
const ExpenseJournalDump = props => {
  // Separate state variables
  const [tableData, setTableData] = useState([]);
  const [tableDisplay, setTableDisplay] = useState([]);
  const [billNumber, setBillNumber] = useState([]);
  const [dropdownStatus] = useState(["Active", "Waiting For Approval"]);
  const [JournalIds, setJournalIDs] = useState([]);
  const [DocRefs, setDocRefs] = useState([]);
  const [DocIds, setDocIDs] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    Status: "",
    docid: "",
    company: "",
    docref: "",
    journalid: ""
  });
  const [filterData, setFilterData] = useState({
    docid: "",
    docref: "",
    journalid: ""
  });
  const [companies, setCompanies] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const downloadLinkRef = useRef(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  let dispatch = useDispatch();
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(({
      res
    }) => {
      setCompanies((res.data || []).sort((a, b) => (a.orgname || "").localeCompare(b.orgname || "")));
      if (res.data.length === 1) {
        handleChange("company", res.data[0]);
      }
      var currentDate = moment();
      var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
      var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
      setFormData(prev => ({
        ...prev,
        fromDate: firstDay,
        toDate: lastDay
      }));
    }).catch(error => console.log(error));
    ;
  }, []);
  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleFilterChange = (name, value) => {
    setFilterData({
      docid: name === "docid" && value || "",
      docref: name === "docref" && value || "",
      journalid: name === "journalid" && value || ""
    });
  };
  useEffect(() => {
    if (filterData.docid === "" && filterData.docref === "" && filterData.journalid === "") {
      setTableDisplay(tableData);
      return;
    }
    let filteredData = tableData.filter(item => {
      return item.CreatedID === filterData.docid || item.DocumentRef === filterData.docref || item.AccountingDocNumber === filterData.journalid;
    });
    setTableDisplay(filteredData);
  }, [filterData.docid, filterData.docref, filterData.journalid]);
  const handleSubmit = () => {
    const {
      fromDate,
      toDate,
      company,
      Status,
      docid
    } = formData;
    dispatch(showLoader());
    getRequest(`api/edureka/ADJournal?FromDate=${fromDate}&ToDate=${toDate}&Status=${Status}&DocID=${docid}&company=${company.orgid}`).then(response => {
      const responseData = JSON.parse(response.res.data);
      setTableDisplay(responseData);
      setTableData(responseData);
      setJournalIDs([...new Set(responseData.map(item => item["AccountingDocNumber"]))]);
      setDocRefs([...new Set(responseData.map(item => item["DocumentRef"]))]);
      setDocIDs([...new Set(responseData.map(item => item["CreatedID"]))]);
    }).catch(err => {
      console.log(err);
    }).finally(() => dispatch(hideLoader()));
  };
  const handleDownload = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.link.click();
    }
  };
  const handleReset = () => {
    setTableData([]);
    setTableDisplay([]);
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData({
      fromDate: firstDay,
      toDate: lastDay,
      type: "",
      company: ""
    });
    setFilterData({
      docid: "",
      docref: "",
      journalid: ""
    });
  };
  return <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography variant="h6">Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete size="small" fullWidth value={formData?.company || null} options={companies || []} getOptionLabel={option => option?.orgname || ""} isOptionEqualToValue={(option, value) => option?.orgid === value?.orgid} onChange={(event, newValue) => handleChange("company", newValue)} renderInput={params => <TextField {...params} label="Company" variant="outlined" name="Company" />} />
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="From" value={formData.fromDate} inputFormat="DD-MM-YYYY" minDate={moment().subtract(10, "year").startOf("year")} maxDate={moment().endOf("year")} views={["year", "month", "day"]} onChange={newValue => handleChange("fromDate", moment(newValue).format("YYYY-MM-DD"))} renderInput={params => <TextField size="small" fullWidth {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="To" value={formData.toDate} inputFormat="DD-MM-YYYY" minDate={moment().subtract(10, "year").startOf("year")} maxDate={moment().endOf("year")} views={["year", "month", "day"]} onChange={newValue => handleChange("toDate", moment(newValue).format("YYYY-MM-DD"))} renderInput={params => <TextField size="small" fullWidth {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={formData?.Status || null} options={dropdownStatus || []} onChange={(event, newValue) => handleChange("Status", newValue)} renderInput={params => <TextField {...params} label="Status" variant="outlined" />} />
            </Grid>

            <Grid item>
              <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!formData.company || formData.company && !formData.Status && !formData.docid}>
                Submit
              </Button>
              &nbsp;
              <Button variant="contained" color="error" onClick={handleReset}>
                Reset
              </Button>
              &nbsp;
              {tableData.length > 0 && <Button variant="contained" color="success">
                  <CSVLink data={tableData} filename={`Expense Journal Dump ${formData.fromDate} to ${formData.toDate}.csv`} ref={downloadLinkRef} target="_blank" style={{
                color: "white",
                textDecoration: "none"
              }}>
                    Download
                  </CSVLink>
                </Button>}
            </Grid>
          </Grid>
          <Typography variant="h6" mt={0.5}>
            Filter
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={filterData?.docid || null} options={DocIds || []} onChange={(event, newValue) => handleFilterChange("docid", newValue)} renderInput={params => <TextField {...params} label="Document ID" variant="outlined" />} />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={filterData?.journalid || null} options={JournalIds || []} onChange={(event, newValue) => handleFilterChange("journalid", newValue)} renderInput={params => <TextField {...params} label="Journal ID" variant="outlined" />} />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size="small" fullWidth value={filterData?.docref || null} options={DocRefs || []} onChange={(event, newValue) => handleFilterChange("docref", newValue)} renderInput={params => <TextField {...params} label="Document Ref" variant="outlined" />} />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {tableData.length > 0 && <Box sx={{
      overflow: "auto"
    }}>
          <Table sx={{
        minWidth: 650
      }}>
              <TableHead>
                <TableRow>
                  {((rowsPerPage > 0 ? tableDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableDisplay) && (rowsPerPage > 0 ? tableDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableDisplay).length > 0 ? Object.keys((rowsPerPage > 0 ? tableDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableDisplay)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {((rowsPerPage > 0 ? tableDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableDisplay) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                          {String(displayVal)}
                        </TableCell>;
            })}
                  </TableRow>)}
              </TableBody>
            </Table>
        </Box>}
    </>;
};
export default ExpenseJournalDump;